// Material Kit 2 React pages
import Tarifas from "pages/Tarifas";

export default function TarifasPage() {
  return <Tarifas />;
}
